/* eslint-disable */
$(document).ready(() => {
    $.extend($.fn.dataTable.defaults, {
        //      autoWidth: false,
        stateSave: true,
        dom: '<"datatable-header"fl><"datatable-scroll"t><"datatable-footer"ip>',
        language: {
            decimal: '',
            emptyTable: 'Tabellen innehåller ingen data',
            info: 'Visar _START_ till _END_ av totalt _TOTAL_ rader',
            infoEmpty: 'Visar 0 till 0 av totalt 0 rader',
            infoFiltered: '(filtrerade från totalt _MAX_ rader)',
            infoPostFix: '',
            thousands: ',',
            lengthMenu: '<span>Visa:</span> _MENU_',
            loadingRecords: 'Laddar...',
            processing: 'Bearbetar...',
            search: '<span>Sök:</span> _INPUT_',
            searchPlaceholder: 'Skriv för att söka...',
            zeroRecords: 'Hittade inga matchande resultat',
            paginate: {
                first: 'Första',
                last: 'Sista',
                next: 'Nästa',
                previous: 'Föregående',
            },
            aria: {
                sortAscending: ': aktivera för att sortera kolumnen i stigande ordning',
                sortDescending: ': aktivera för att sortera kolumnen i fallande ordning',
            },
        },
        drawCallback() {
            $(this).find('tbody tr').slice(-3).find('.dropdown, .btn-group')
                .addClass('dropup');
        },
        preDrawCallback() {
            $(this).find('tbody tr').slice(-3).find('.dropdown, .btn-group')
                .removeClass('dropup');
        },
    });

    $('.js-datatable').each(function () {
        $(this).DataTable();
    });
    $('.js-datatable-full').each(function () {
        $(this).DataTable({
            paging: false,
        });
    });
    $('.js-datatable-long').each(function () {
        $(this).DataTable({
            aLengthMenu: [
                [50, 100, 200, 500, -1],
                [50, 100, 200, 500, 'All'],
            ],
            iDisplayLength: 100,
        });
    });

    $('.js-select').each(function () {
        $(this).select2({
            minimumResultsForSearch: Infinity,
        });
    });

    $('.js-select-search').each(function () {
        $(this).select2();
    });

    $('.sidebar-main-toggle').click(() => {
        const toggle_status = getCookie('sidebar_hide');
        if (toggle_status == '1') {
            document.cookie = 'sidebar_hide=0';
        } else {
            document.cookie = 'sidebar_hide=1';
        }
    });

    // $('.switch').bootstrapSwitch();
});

function getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
/** es-lint enable */
